import { API_BASE_URL } from "@/api/api.config";
import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import stringifyParams from "@/utils/stringifyParams";

const fetchSuggestionsService = async (text = "") => {
  const resource = `${MONOLITH_ORIGIN}/agatha/api/suggestions/`;

  const queryString = stringifyParams({
    fragment: text,
    page_size: 5,
    segmented_trending: true,
    strategy: "ranked",
  });

  try {
    const response = await fetch(`${resource}${queryString}`);
    return await response?.json();
  } catch (error) {
    return error;
  }
};

const fetchLangstonSuggestionsService = async (text = "") => {
  const resource = `${API_BASE_URL}/api/v3/content/delivery/suggestions/`;

  const queryString = stringifyParams({
    needle: text,
    limit: 5,
  });

  try {
    const response = await fetch(`${resource}${queryString}`, {
      method: "GET",
      credentials: "include",
    });
    return await response?.json();
  } catch (error) {
    return error;
  }
};

export { fetchSuggestionsService, fetchLangstonSuggestionsService };
